import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drag_table",
  "use": "icon-drag_table-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-drag_table\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M18,8h0a1,1,0,0,1-1,1H7A1,1,0,0,1,6,8H6A1,1,0,0,1,7,7H17A1,1,0,0,1,18,8Zm-1,3H7a1,1,0,0,0-1,1H6a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1h0A1,1,0,0,0,17,11Zm0,4H7a1,1,0,0,0-1,1H6a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1h0A1,1,0,0,0,17,15Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol